import { DirectiveOptions } from "vue";
import { DirectiveBinding } from "vue/types/options";

function setPosition(element: HTMLElement, binding: DirectiveBinding) {
  element.style.width = binding.value.width + "px";
  element.style.height = binding.value.height + "px";

  const mobileWidgets = document.querySelectorAll(".homepage-card-image");
  let index = 0;
  const length = mobileWidgets.length;
  for (; index < length; index++) {
    (mobileWidgets[index] as HTMLElement).style["height"] =
      binding.value.width * 0.5 + "px";
  }
}

const mobileWidget: DirectiveOptions = {
  inserted(el, binding) {
    setPosition(el, binding);
  },
  update(el, binding) {
    setPosition(el, binding);
  }
};

export default mobileWidget;
